// src/api/axiosInstance.js
import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});

instance.interceptors.request.use(
  (config) => {
    const adminToken = localStorage.getItem('adminToken'); // Recuperar el token de localStorage
    addDataToRequest(config, 'adminToken', adminToken);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

function addDataToRequest(config, dataKey, dataValue) {
  // Solo agregar el parámetro si el valor es válido
  if (!dataValue || dataValue === 'undefined' || dataValue === null) {
    return;
  }

  const method = (config.method || 'get').toLowerCase();

  if (method === 'post' || method === 'put' || method === 'patch') {
    // Si el body es FormData, usamos append
    if (config.data instanceof FormData) {
      config.data.append(dataKey, dataValue);
    } else {
      config.data = {
        ...(config.data || {}),
        [dataKey]: dataValue,
      };
    }
  } else {
    config.params = {
      ...(config.params || {}),
      [dataKey]: dataValue,
    };
  }
}

export default instance;
